import {http} from '@/http'

export default {
  getBalance(employeeId) {
    return http.get(`/vacations/balance/${employeeId}`)
  },
  getBalanceByContract(contractId) {
    return http.get('/vacations/balance', { params: { contractId } })
  },
  getBalanceByEmployeeCompany(employeeId, companyId) {
    return http.get('/vacations/balance', { params: { employeeId, companyId } })
  },
  getPeriods(contractId) {
    return http.get(`/vacations/periods/${contractId}`)
  },
  getAvailablePeriods(employeeId, companyId) {
    return http.get(`/vacations/employees/${employeeId}/companies/${companyId}/available-periods`)
  },
  checkOverlap(employeeId, startDate, endDate) {
    return http.get('/vacations/check-overlap', { params: { employeeId, startDate, endDate } })
  },
  createRequest(data) {
    return http.post('/vacations/requests', data)
  },
  createHistoricalRequest(data) {
    return http.post('/vacations/requests/historical', data)
  },
  getAdvanceDaysConfig() {
    return http.get('/vacations/config/advance-days')
  },
  getRequests(params) {
    return http.get('/vacations/requests', {params})
  },
  getRequest(id) {
    return http.get(`/vacations/requests/${id}`)
  },
  updateRequest(id, data) {
    return http.put(`/vacations/requests/${id}`, data)
  },
  getRequestsByEmployee(employeeId) {
    return http.get(`/vacations/requests/employee/${employeeId}`)
  },
  approveRequest(id) {
    return http.put(`/vacations/requests/${id}/approve`)
  },
  rejectRequest(id, data) {
    return http.put(`/vacations/requests/${id}/reject`, data)
  },
  cancelRequest(id, data) {
    return http.put(`/vacations/requests/${id}/cancel`, data)
  },
  annulRequest(id, reason) {
    return http.patch(`/vacations/requests/${id}/annul`, { reason })
  },
  annulBatch(ids, reason) {
    return http.patch('/vacations/requests/annul-batch', { ids, reason })
  },
  enjoy(id) {
    return http.put(`/vacations/requests/${id}/enjoy`)
  },
  markPaid(id, formData) {
    return http.put(`/vacations/requests/${id}/pay`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
  // Venta de vacaciones (D.L. 713 Art. 19): multipart soldDays + acuerdo escrito.
  sellVacationDays(periodId, formData) {
    return http.post(`/vacations/periods/${periodId}/sell`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
  editPayment(id, formData) {
    return http.put(`/vacations/requests/${id}/pay/edit`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
  downloadReceipt(id) {
    return http.get(`/vacations/requests/${id}/pay/receipt`, { responseType: 'blob' })
  },
  getBanks() {
    return http.get('/banks/active')
  },
  uploadDocument(requestId, formData) {
    return http.post(`/vacations/requests/${requestId}/documents`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
  listDocuments(requestId) {
    return http.get(`/vacations/requests/${requestId}/documents`)
  },
  downloadDocument(requestId, docId) {
    return http.get(`/vacations/requests/${requestId}/documents/${docId}/download`, { responseType: 'blob' })
  },
  deleteDocument(requestId, docId) {
    return http.delete(`/vacations/requests/${requestId}/documents/${docId}`)
  },
  downloadXlsx(data) {
    return http.post('/vacations/requests/xlsx', data, {responseType: 'blob'})
  },
  getPeriodsList(params) {
    return http.get('/vacations/periods', { params })
  },
  downloadPeriodsXlsx(params) {
    return http.get('/vacations/periods/xlsx', { params, responseType: 'blob' })
  },
}
